export default {
  dreamCodeHero: {
    label: 'PROGRAM',
    title: 'DREAM CODE',
    subtitle: '成長を構造から設計する教育フレームワーク',
  },
  whyChange: {
    label: 'WHY CHANGE',
    title: 'なぜ、人は変われるのか。',
    body1: '多くの人が「変わりたい」と願いながら、変化が続かない理由は、意志の弱さではなく"構造"にあります。',
    body2: '思考は行動を生み、行動は結果を生みます。\nしかし、その思考や行動は、これまでの経験によって形成された認知パターンに影響されています。',
    highlight: 'DREAM CODEは、その無意識の構造を可視化し、再設計する教育プロセスです。\n一時的な高揚ではなく、再現可能な変化を目指します。',
  },
  cycle: {
    label: 'CYCLE STRUCTURE',
    title: '変化を定着させる、\n4段階の循環設計',
    stage1: { number: '01', title: '基盤形成', subtitle: '自己理解と構造認識', desc: '自分の思考パターンや行動傾向を客観視し、無意識の前提を明確にします。' },
    stage2: { number: '02', title: '再構築', subtitle: '思考回路の再設計', desc: '繰り返しの実践と内省により、新たな認知パターンを形成します。' },
    stage3: { number: '03', title: '未来設計', subtitle: '戦略的ビジョン構築', desc: '望む未来像を具体化し、行動計画として落とし込みます。' },
    stage4: { number: '04', title: '自律発展', subtitle: '持続可能な成長の確立', desc: '学びを循環させ、自律的に発展できる状態へ移行します。' },
    centerLabel: 'CYCLE',
    centerText: '循環設計',
    footer: '学ぶ、体験する、振り返る、定着させる。\nこの循環こそが、持続的変化を生み出します。',
  },
  scientific: {
    label: 'SCIENTIFIC BASIS',
    title: '科学的知見に基づく教育設計',
    keyword1: '神経可塑性',
    keyword2: 'ヘブの法則',
    keyword3: '認知行動理論',
    keyword4: '自己効力感理論',
    body1: 'DREAM CODEは、特定の単一理論に依拠するものではありません。',
    body2: '神経可塑性、ヘブの法則、認知行動理論、自己効力感理論など、複数の学術的知見から教育設計上の示唆を得ています。',
    body3: '思考が直接物理現象を変化させると主張するものではありません。\nしかし、思考が注意・選択・行動に影響を与えることは、多くの研究によって示されています。',
    conclusion1: '構造が変われば、\n行動が変わる。',
    conclusion2: '行動が変われば、\n結果は変わる。',
    conclusion3: 'この連鎖を教育として設計しています。',
  },
  integration: {
    label: 'INTEGRATION',
    title: '構造を変えれば、未来は変わる。',
    body1: '変化は偶然ではありません。',
    body2: '原理を理解し、体験を通じて定着させることで、再現可能な成長は生まれます。',
    body3: 'DREAM CODEは、その構造を提示する教育フレームワークです。',
  },
  cta: {
    button1: '個人で参加を検討する',
    button2: '導入について相談する',
  },
  fourFields: {
    label: 'FOUR FIELDS',
    title: '4つの学術的視座からの統合',
    philosophy: {
      label: '成功哲学',
      labelEn: 'SUCCESS PHILOSOPHY',
      goal: '育成目標：成功脳（現実と真実脳）',
      goalEn: 'Architectural Intelligence',
      description: '成功哲学は、成果を生み出す思考原理を体系的に整理した分野です。歴史的思想家や現代研究を踏まえ、「結果を生む思考習慣」に焦点を当てます。感情論ではなく、原理としての成功を扱います。',
    },
    brain: {
      label: '基礎脳科学',
      labelEn: 'BRAIN SCIENCE',
      goal: '育成目標：人格脳（反復脳、会話脳、リーダー脳）',
      goalEn: 'Character Intelligence',
      description: '神経可塑性やヘブの法則は、経験と反復によって神経回路が強化されることを示しています。DREAM CODEでは、反復と内省を組み合わせることで、新たな思考回路の形成を促します。',
    },
    psychology: {
      label: '行動心理学',
      labelEn: 'BEHAVIORAL PSYCHOLOGY',
      goal: '育成目標：忍耐脳（愛され脳、人間関係脳）',
      goalEn: 'Relational Intelligence',
      description: '認知行動理論は、出来事ではなく「解釈」が行動を決定すると示します。信念は選択に影響し、選択は結果を方向づけます。行動レベルでの実践設計を重視します。',
    },
    quantum: {
      label: '基礎量子力学',
      labelEn: 'QUANTUM MECHANICS',
      goal: '育成目標：感情脳（感情経営脳、目標達成脳、資産形成脳）',
      goalEn: 'Emotional Intelligence',
      description: '量子力学は物理現象を扱う学問であり、人間の願望実現を直接説明するものではありません。しかし、「観測」「不確実性」「可能性」という概念は、現実認識の構造を再考する視座を与えます。DREAM CODEでは、これらを哲学的・概念的枠組みとして位置づけています。',
    },
    courses: {
      '01': { title: '現実と真実の法則', subtitle: '夢実現100%! 想像と選択の理論' },
      '02': { title: '夢実現の法則', subtitle: '成功法則3原則の理論' },
      '03': { title: 'セルフ・イメージの法則', subtitle: '自己像の完成理論' },
      '04': { title: 'サイコ・サイバネティックスの法則', subtitle: '目標追求装置の理論' },
      '05': { title: '信念の法則', subtitle: '4人の偉人に共通する信念理論' },
      '06': { title: '思い込みの法則', subtitle: 'プラシーボ・ノーシーボ効果理論' },
      '07': { title: '勝者と敗者の5つの法則', subtitle: '勝者と敗者の習慣脳理論' },
      '08': { title: '実践信念育成5段階法則', subtitle: '信念完全マスター理論' },
      '09': { title: '顕在意識と潜在意識の法則', subtitle: '顕在意識×潜在意識×RAS理論' },
      '10': { title: '本気の法則', subtitle: 'ソクラテス哲学理論' },
      '11': { title: 'パラダイム・シフトの法則', subtitle: '自己中心の脱却理論' },
      '12': { title: '実践・禁止事項の法則', subtitle: '日常生活適応6つの理論' },
      '13': { title: 'あがり症解放の法則', subtitle: '脳神経細胞信号伝達理論' },
      '14': { title: '自己報酬神経群の法則', subtitle: 'マズロー欲求段階説理論' },
      '15': { title: '10000時間の法則', subtitle: '反復による脳回路育成理論' },
      '16': { title: '3大神経伝達物質の法則', subtitle: '絶対必須化学物質理論' },
      '17': { title: '7つの力(実力)の法則', subtitle: '成功脳回路育成4段階理論' },
      '18': { title: 'コミュニケーションの法則', subtitle: '究極の会話術理論' },
      '19': { title: '5段階反論処理の法則', subtitle: 'クレーム対処法理論' },
      '20': { title: '脳内化学物質の法則', subtitle: 'ギャンブル&恋愛対処理論' },
      '21': { title: '3原則信頼獲得の法則', subtitle: '究極の部下育成理論' },
      '22': { title: '最強の組織育成構築の法則', subtitle: '究極の組織育成術理論' },
      '23': { title: 'ストレス・コントロールの法則', subtitle: 'ストレス対処法理論' },
      '24': { title: '全責任の法則', subtitle: 'たられば禁止理論' },
      '25': { title: '愛の4段階の法則', subtitle: '人格形成4原則理論' },
      '26': { title: '『愛され脳回路』の法則', subtitle: '認められたい・愛されたい理論' },
      '27': { title: '本能的欲求と意図的欲求の法則', subtitle: 'プロとアマ理論' },
      '28': { title: '究極のやる気法則', subtitle: 'やる気の出し方出させ方理論' },
      '29': { title: '恐れ・怒りの法則', subtitle: '自我からの解放理論' },
      '30': { title: '究極の黄金律の法則', subtitle: '与える原則理論' },
      '31': { title: '究極の決断法則', subtitle: '選択の自由理論' },
      '32': { title: '成功する価値観の法則', subtitle: 'アクト・アズ・イフ理論' },
      '33': { title: '偉人秘伝の法則', subtitle: '3歳・8歳・18歳理論' },
      '34': { title: '破れ窓理論の法則', subtitle: '心と体の関係理論' },
      '35': { title: '他人依存脳からの脱却の法則', subtitle: '自己確立脳回路育成理論' },
      '36': { title: '認知症改善脳回路の法則', subtitle: 'センター方式脳回路育成理論' },
      '37': { title: '量子医学の法則', subtitle: '科学×哲学×波動共鳴×人間意識×AI解析理論' },
      '38': { title: '波動共鳴の法則', subtitle: '喜び・祈り・感謝脳回路理論' },
      '39': { title: '量子場の法則', subtitle: 'ロイヤル・レイモンド・ライフ博士 ガン細胞除去レイ・マシーン理論' },
      '40': { title: '量子医学×波動×AIの法則', subtitle: '未来医療理論' },
      '41': { title: '創造的販売法の法則', subtitle: '営業脳回路育成理論' },
      '42': { title: '成功脳回路育成4段階の法則', subtitle: 'スポーツ脳・健康脳回路育成理論' },
      '43': { title: '波動宣言×AIの法則', subtitle: 'アファーメーション理論' },
      '44': { title: '波動動画×AIの法則', subtitle: 'ビジュアリゼーション理論' },
      '45': { title: '金銭哲学3つの法則', subtitle: '大富豪実践1 貯金理論' },
      '46': { title: '資産形成10回倍増の法則', subtitle: '資産形成3原則理論' },
      '47': { title: '時間=お金=労力の法則', subtitle: '浪費・消費・投資理論' },
      '48': { title: '永続的成功与える法則', subtitle: '全人格の形成理論' },
    },
  },
};